import { render, staticRenderFns } from "./PurchaseOrderDetail.vue?vue&type=template&id=160363f0&scoped=true&"
import script from "./PurchaseOrderDetail.vue?vue&type=script&lang=js&"
export * from "./PurchaseOrderDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "160363f0",
  null
  
)

export default component.exports